import axios from "axios";


export const getIncidentSettings = async () => {
    const url = `/api/v1/settings/incident`;
    const res = await axios.get(url);
    return res.data;
}